import React from 'react'

import logo from '../images/logo.png'
import {Link, useLocation} from 'react-router-dom'
import Socials from './Socials'

const Menu = () => {
  const location = useLocation()

  if (location.pathname === '/rating') {
    return <Link to={'/'} className="default-link">
      Главная
    </Link>
  }

  return <Link to={'/rating'} className="default-link">
    Рейтинг
  </Link>
}

const Header = () => {
  return (
    <header>
      <a href={'https://sport-express.ru/'} target="_blank" rel="noreferrer">
        <img src={logo} alt=""/>
      </a>
      <Menu />
      <Socials/>
    </header>
  )
}

export default Header
